import {
  ADD_UPDATE_BANK_MASTER,
  ADD_UPDATE_BRANCH_MASTER,
  ADD_UPDATE_BRANCH_PRODUCT,
  ADD_UPDATE_COLENDING_MASTER,
  ADD_UPDATE_LOAN_PRODUCT_MASTER,
  ADD_UPDATE_PINCODE_MASTER,
  ADD_UPDATE_ROLE_MASTER,
  ADD_UPDATE_ROLE_REPORT,
  ADD_UPDATE_STATE_MASTER,
  BR_NET_PRE_CLOSURE,
  BULK_DOWNLOAD_MASTER,
  BULK_UPLOAD_MASTER,
  FETCH_ALLOWED_DOCUMENT_LIST,
  FETCH_BANK_DETAILS_BY_IFSC,
  FETCH_BANK_MASTER,
  FETCH_BRANCH_MASTER,
  FETCH_BRANCH_PRODUCT,
  FETCH_CD_MASTER,
  FETCH_CO_LENDING_MASTER,
  FETCH_CONSUMER_DETAILS,
  FETCH_CONVERSATION,
  FETCH_CUSTOMER_DETAILS,
  FETCH_CUSTOMER_LOAN_DETAILS,
  FETCH_CUSTOMER_LOANS,
  FETCH_CUSTOMERS,
  FETCH_DOCUMENT_TEMPLATE,
  FETCH_GLOBAL_PERMISSION,
  FETCH_KYC_DOCUMENTS,
  FETCH_KYC_DOCUMENTS_LIST,
  FETCH_LOAN_SEARCH_PRODUCT,
  FETCH_NOTIFICATION,
  FETCH_PARTNER_DROPDOWN,
  FETCH_PINCODE_MASTER,
  FETCH_PREVIOUS_KYC,
  FETCH_PRODUCT_PERMISSION,
  FETCH_PRODUCT_SERVICES,
  FETCH_PRODUCT_STAGES,
  FETCH_REPORT_DROPDOWN,
  FETCH_ROLE_LIST,
  FETCH_ROLE_MASTER,
  FETCH_ROLE_REPORT,
  FETCH_SERVICE_LIST,
  FETCH_STATE_MASTER,
  FETCH_TEMPLATE_VARIABLES,
  FETCH_USER_BRANCHES,
  FETCH_USER_MASTER,
  FETCH_USER_PRODUCT_CATEGORIES,
  FORCE_LOGOUT,
  LMS_BR_NET_API_CALL,
  LOGGED_IN_USER_LIST,
  LOGGED_ROLE_REPORT,
  NOTIFICATION_COUNT,
  PARTNER_CODE_DROPDOWN,
  PRODUCT_BY_BRANCH_USER,
  PRODUCT_CATEGORY_DROPDOWN,
  SAVE_DOCUMENT_TEMPLATE,
  SAVE_GLOBAL_PERMISSION,
  SAVE_PRODUCT_PERMISSION,
  SAVE_USER_MASTER,
  TAG_USER_DROPDOWN,
  UPDATE_CONSUMER_MASTER,
  UPDATE_NOTIFICATION,
  UPSERT_CONVERSATION,
  USER_ROLE_NAME_LIST,
  PRODUCT_DROPDOWN,
  FETCH_DAIRY_MASTER,
  ADD_UPDATE_DAIRY_MASTER,
  BRANCH_TO_PARALLEL_WORKFLOW,
  ADD_UPDATE_BRANCH_PARALLEL,
  FETCH_ESTAMP_MASTER,
  ADD_UPDATE_ESTAMP_MASTER,
  FETCH_EMAIL_TEMPLATE_MASTER,
  UPSERT_EMAIL_TEMPLATE,
  FETCH_EMAIL_TEMPLATE_NAME,
  FETCH_ACTIVE_CO_LENDERS,
  FETCH_CATTLE_SUB_TYPES,
  FETCH_VENDOR_TYPES,
  FETCH_ESTAMP_STATES,
  FETCH_DROPDOWN_MASTER,
  ADD_UPDATE_DROPDOWN_MASTER,
} from '../../resources/endPoint';

export const fetchLoanSearchProduct = data => {
  return {
    url: FETCH_LOAN_SEARCH_PRODUCT,
    payload: data,
    method: 'post',
    tag: 'FETCH_LOAN_SEARCH_PRODUCT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchBankDetailsByIFSC = data => {
  return {
    url: FETCH_BANK_DETAILS_BY_IFSC,
    payload: data,
    method: 'post',
    tag: 'FETCH_BANK_DETAILS_BY_IFSC',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchBankMaster = data => {
  return {
    url: FETCH_BANK_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_BANK_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchCoLendingMaster = data => {
  return {
    url: FETCH_CO_LENDING_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_CO_LENDING_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchPincodeMaster = data => {
  return {
    url: FETCH_PINCODE_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_PINCODE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchBranchMaster = data => {
  return {
    url: FETCH_BRANCH_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_BRANCH_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchStateMaster = data => {
  return {
    url: FETCH_STATE_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_STATE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdateBankMaster = data => {
  return {
    url: ADD_UPDATE_BANK_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_BANK_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdatePincodeMaster = data => {
  return {
    url: ADD_UPDATE_PINCODE_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_PINCODE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdateStateMaster = data => {
  return {
    url: ADD_UPDATE_STATE_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_STATE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const bulkUploadMaster = data => ({
  url: BULK_UPLOAD_MASTER,
  payload: data,
  method: 'post',
  tag: 'BULK_UPLOAD_MASTER',
  headers: { 'Content-Type': 'multipart/form-data' },
  authRequired: true,
  csrfToken: true,
  service: '',
});
export const bulkDownloadMaster = data => ({
  url: BULK_DOWNLOAD_MASTER,
  payload: data,
  method: 'post',
  tag: 'BULK_DOWNLOAD_MASTER',
  headers: { 'content-type': 'application/json' },
  authRequired: true,
  csrfToken: true,
  service: '',
});
export const addUpdateBranchMaster = data => {
  return {
    url: ADD_UPDATE_BRANCH_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_BRANCH_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdateColendingMaster = data => {
  return {
    url: ADD_UPDATE_COLENDING_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_COLENDING_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetch_partner_dropdown = data => {
  return {
    url: FETCH_PARTNER_DROPDOWN,
    payload: data,
    method: 'get',
    tag: 'FETCH_PARTNER_DROPDOWN',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const addUpdateLoanProductMaster = data => {
  return {
    url: ADD_UPDATE_LOAN_PRODUCT_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_LOAN_PRODUCT_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchRoleAndReportMaster = data => {
  return {
    url: FETCH_ROLE_REPORT,
    payload: data,
    method: 'post',
    tag: 'FETCH_ROLE_REPORT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchRoleListDropdown = data => {
  return {
    url: FETCH_ROLE_LIST,
    payload: data,
    method: 'get',
    tag: 'FETCH_ROLE_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchReportDropdown = data => {
  return {
    url: FETCH_REPORT_DROPDOWN,
    payload: data,
    method: 'post',
    tag: 'FETCH_REPORT_DROPDOWN',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdateRoleReport = data => {
  return {
    url: ADD_UPDATE_ROLE_REPORT,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_ROLE_REPORT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchBranchToProductMaster = data => {
  return {
    url: FETCH_BRANCH_PRODUCT,
    payload: data,
    method: 'post',
    tag: 'FETCH_BRANCH_PRODUCT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchProductCategoryDropdown = data => {
  return {
    url: PRODUCT_CATEGORY_DROPDOWN,
    payload: data,
    method: 'post',
    tag: 'PRODUCT_CATEGORY_DROPDOWN',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchProductDropdown = data => {
  return {
    url: PRODUCT_DROPDOWN,
    payload: data,
    method: 'get',
    tag: 'PRODUCT_DROPDOWN',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdateBranchProduct = data => {
  return {
    url: ADD_UPDATE_BRANCH_PRODUCT,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_BRANCH_PRODUCT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const loggedRoleReport = data => {
  return {
    url: LOGGED_ROLE_REPORT,
    payload: data,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
  };
};
export const fetchUserMaster = data => {
  return {
    url: FETCH_USER_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_USER_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addUpdateUserMaster = data => {
  return {
    url: SAVE_USER_MASTER,
    payload: data,
    method: 'post',
    tag: 'SAVE_USER_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const productByBranchUser = data => {
  return {
    url: PRODUCT_BY_BRANCH_USER,
    payload: data,
    method: 'post',
    tag: 'PRODUCT_BY_BRANCH_USER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const forceLogout = data => {
  return {
    url: FORCE_LOGOUT,
    payload: data,
    method: 'post',
    tag: 'FORCE_LOGOUT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const partnerCodeDropdown = data => {
  return {
    url: PARTNER_CODE_DROPDOWN,
    payload: data,
    method: 'get',
    tag: 'PARTNER_CODE_DROPDOWN',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const loggedInUserList = data => {
  return {
    url: LOGGED_IN_USER_LIST,
    payload: data,
    method: 'post',
    tag: 'LOGGED_IN_USER_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const userRoleNameList = data => {
  return {
    url: USER_ROLE_NAME_LIST,
    payload: data,
    method: 'get',
    tag: 'USER_ROLE_NAME_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const fetchCountNotification = data => {
  return {
    url: NOTIFICATION_COUNT,
    payload: data,
    method: 'post',
    tag: 'NOTIFICATION_COUNT',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchNotificationDetails = data => {
  return {
    url: FETCH_NOTIFICATION,
    payload: data,
    method: 'post',
    tag: 'FETCH_NOTIFICATION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const updateNotification = data => {
  return {
    url: UPDATE_NOTIFICATION,
    payload: data,
    method: 'post',
    tag: 'UPDATE_NOTIFICATION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchPreviousKyc = data => {
  return {
    url: FETCH_PREVIOUS_KYC,
    payload: data,
    method: 'post',
    tag: 'FETCH_PREVIOUS_KYC',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchUserBranches = data => {
  return {
    url: FETCH_USER_BRANCHES,
    payload: data,
    method: 'get',
    tag: 'FETCH_USER_BRANCHES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const upsertConversation = data => {
  return {
    url: UPSERT_CONVERSATION,
    payload: data,
    method: 'post',
    tag: 'UPSERT_CONVERSATION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const tagUserDropdown = data => {
  return {
    url: TAG_USER_DROPDOWN,
    payload: data,
    method: 'post',
    tag: 'TAG_USER_DROPDOWN',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchConversation = data => {
  return {
    url: FETCH_CONVERSATION,
    payload: data,
    method: 'post',
    tag: 'FETCH_CONVERSATION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchRoleMaster = data => {
  return {
    url: FETCH_ROLE_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_ROLE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const addEditRoleMaster = data => {
  return {
    url: ADD_UPDATE_ROLE_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_ROLE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchServiceList = data => {
  return {
    url: FETCH_SERVICE_LIST,
    payload: data,
    method: 'post',
    tag: 'FETCH_SERVICE_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};

export const fetchProductServices = data => {
  return {
    url: FETCH_PRODUCT_SERVICES,
    payload: data,
    method: 'post',
    tag: 'FETCH_PRODUCT_SERVICES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchProductStages = data => {
  return {
    url: FETCH_PRODUCT_STAGES,
    payload: data,
    method: 'post',
    tag: 'FETCH_PRODUCT_STAGES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchGlobalPermission = data => {
  return {
    url: FETCH_GLOBAL_PERMISSION,
    payload: data,
    method: 'post',
    tag: 'FETCH_GLOBAL_PERMISSION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchProductPermission = data => {
  return {
    url: FETCH_PRODUCT_PERMISSION,
    payload: data,
    method: 'post',
    tag: 'FETCH_PRODUCT_PERMISSION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const saveGlobalPermission = data => {
  return {
    url: SAVE_GLOBAL_PERMISSION,
    payload: data,
    method: 'post',
    tag: 'SAVE_GLOBAL_PERMISSION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const saveProductPermission = data => {
  return {
    url: SAVE_PRODUCT_PERMISSION,
    payload: data,
    method: 'post',
    tag: 'SAVE_PRODUCT_PERMISSION',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchAllowedDocumentList = data => {
  return {
    url: FETCH_ALLOWED_DOCUMENT_LIST,
    payload: data,
    method: 'post',
    tag: 'FETCH_ALLOWED_DOCUMENT_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};

export const fetchCustomerList = data => {
  return {
    url: FETCH_CUSTOMERS,
    payload: data,
    method: 'post',
    tag: 'FETCH_CUSTOMERS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchCustomerDetails = data => {
  return {
    url: FETCH_CUSTOMER_DETAILS,
    payload: data,
    method: 'post',
    tag: 'FETCH_CUSTOMER_DETAILS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchCustomerLoans = data => {
  return {
    url: FETCH_CUSTOMER_LOANS,
    payload: data,
    method: 'post',
    tag: 'FETCH_CUSTOMER_LOANS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchCustomerLoanDetails = data => {
  return {
    url: FETCH_CUSTOMER_LOAN_DETAILS,
    payload: data,
    method: 'post',
    tag: 'FETCH_CUSTOMER_LOAN_DETAILS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchCustomerDocumentsList = data => {
  return {
    url: FETCH_KYC_DOCUMENTS_LIST,
    payload: data,
    method: 'post',
    tag: 'FETCH_KYC_DOCUMENTS_LIST',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchCustomerDocuments = data => {
  return {
    url: FETCH_KYC_DOCUMENTS,
    payload: data,
    method: 'post',
    tag: 'FETCH_KYC_DOCUMENTS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const lmsBrNetApiCall = data => {
  return {
    url: LMS_BR_NET_API_CALL,
    payload: data,
    method: 'post',
    tag: 'LMS_BR_NET_API_CALL',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchDocumentTemplate = data => {
  return {
    url: FETCH_DOCUMENT_TEMPLATE,
    payload: data,
    method: 'post',
    tag: 'FETCH_DOCUMENT_TEMPLATE',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const saveDocumentTemplate = data => {
  return {
    url: SAVE_DOCUMENT_TEMPLATE,
    payload: data,
    method: 'post',
    tag: 'SAVE_DOCUMENT_TEMPLATE',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const fetchTemplateVariables = data => {
  return {
    url: FETCH_TEMPLATE_VARIABLES,
    payload: data,
    method: 'post',
    tag: 'FETCH_TEMPLATE_VARIABLES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};
export const brNetPreclosure = data => {
  return {
    url: BR_NET_PRE_CLOSURE,
    payload: data,
    method: 'post',
    tag: 'BR_NET_PRE_CLOSURE',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: 'loan-service',
  };
};

export const fetchUserProductCategories = data => {
  return {
    url: FETCH_USER_PRODUCT_CATEGORIES,
    payload: data,
    method: 'get',
    tag: 'FETCH_USER_PRODUCT_CATEGORIES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};

export const fetchConsumerDetails = data => {
  return {
    url: FETCH_CONSUMER_DETAILS,
    payload: data,
    method: 'post',
    tag: 'FETCH_CONSUMER_DETAILS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const updateConsumerMaster = data => {
  return {
    url: UPDATE_CONSUMER_MASTER,
    payload: data,
    method: 'post',
    tag: 'UPDATE_CONSUMER_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchCdMaster = data => {
  return {
    url: FETCH_CD_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_CD_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchDairyMaster = data => {
  return {
    url: FETCH_DAIRY_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_DAIRY_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const branchToParallelWorkflow = data => {
  return {
    url: BRANCH_TO_PARALLEL_WORKFLOW,
    payload: data,
    method: 'post',
    tag: 'BRANCH_TO_PARALLEL_WORKFLOW',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const addUpdateBranchParallel = data => {
  return {
    url: ADD_UPDATE_BRANCH_PARALLEL,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_BRANCH_PARALLEL',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const addUpdateDairyMaster = data => {
  return {
    url: ADD_UPDATE_DAIRY_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_DAIRY_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchEStampMaster = data => {
  return {
    url: FETCH_ESTAMP_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_ESTAMP_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const addUpdateEStampMaster = data => {
  return {
    url: ADD_UPDATE_ESTAMP_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_ESTAMP_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchEmailTemplateMaster = data => {
  return {
    url: FETCH_EMAIL_TEMPLATE_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_EMAIL_TEMPLATE_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const upsertEmailTemplate = data => {
  return {
    url: UPSERT_EMAIL_TEMPLATE,
    payload: data,
    method: 'post',
    tag: 'UPSERT_EMAIL_TEMPLATE',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchEmailTemplateName = () => {
  return {
    url: FETCH_EMAIL_TEMPLATE_NAME,
    payload: {},
    method: 'post',
    tag: 'FETCH_EMAIL_TEMPLATE_NAME',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchActiveCoLenders = () => {
  return {
    url: FETCH_ACTIVE_CO_LENDERS,
    payload: {},
    method: 'post',
    tag: 'FETCH_ACTIVE_CO_LENDERS',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchCattleSubTypes = data => {
  return {
    url: FETCH_CATTLE_SUB_TYPES,
    payload: data,
    method: 'post',
    tag: 'FETCH_CATTLE_SUB_TYPES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchVendorTypes = data => {
  return {
    url: FETCH_VENDOR_TYPES,
    payload: data,
    method: 'post',
    tag: 'FETCH_VENDOR_TYPES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchEstampStates = data => {
  return {
    url: FETCH_ESTAMP_STATES,
    payload: data,
    method: 'post',
    tag: 'FETCH_ESTAMP_STATES',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const fetchDropdownMaster = data => {
  return {
    url: FETCH_DROPDOWN_MASTER,
    payload: data,
    method: 'post',
    tag: 'FETCH_DROPDOWN_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
export const addUpdateDropdownMaster = data => {
  return {
    url: ADD_UPDATE_DROPDOWN_MASTER,
    payload: data,
    method: 'post',
    tag: 'ADD_UPDATE_DROPDOWN_MASTER',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    csrfToken: false,
    service: 'master-service',
  };
};
